module.exports = __webpack_public_path__ + "img/social.73729025.png";